import { s as subscribe } from "../../../../../../chunks/utils.js";
import { c as create_ssr_component, d as add_attribute, v as validate_component, e as escape } from "../../../../../../chunks/ssr.js";
import { p as page } from "../../../../../../chunks/stores.js";
import { C as CardLayout } from "../../../../../../chunks/CardLayout.js";
import { B as Button } from "../../../../../../chunks/Button.js";
import { L as Listgroup } from "../../../../../../chunks/Listgroup.js";
import { twMerge } from "tailwind-merge";
import { g as globalConfirm } from "../../../../../../chunks/modal.js";
const Skeleton = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let outDivclass;
  const sizes = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    xxl: "max-w-2xl"
  };
  let { divClass = "animate-pulse" } = $$props;
  let { size = "sm" } = $$props;
  if ($$props.divClass === void 0 && $$bindings.divClass && divClass !== void 0) $$bindings.divClass(divClass);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  outDivclass = twMerge(sizes[size], divClass, $$props.class);
  return `<div role="status"${add_attribute("class", outDivclass, 0)}><div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-1/2 mb-4"></div> <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-9/12 mb-2.5"></div> <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div> <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div> <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10/12 mb-2.5"></div> <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-11/12 mb-2.5"></div> <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-9/12"></div> <span class="sr-only" data-svelte-h="svelte-1wtojot">Loading...</span></div> `;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  let $$unsubscribe_globalConfirm;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$unsubscribe_globalConfirm = subscribe(globalConfirm, (value) => value);
  let employee = $page.data.employee;
  $$unsubscribe_page();
  $$unsubscribe_globalConfirm();
  return `<div class="grid grid-cols-4 gap-3"><div class="space-y-3">${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "User" }, {}, {
    default: () => {
      return `<p>${escape(employee.email)}</p> <p class="pt-2">${escape(employee.mobile)}</p> <p class="pt-2"><strong data-svelte-h="svelte-e36bmp">ID</strong> ${escape(employee.userId)}</p>`;
    }
  })} ${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Devices" }, {}, {
    default: () => {
      return `${employee.connects?.length > 0 ? `${validate_component(Listgroup, "Listgroup").$$render(
        $$result,
        {
          active: true,
          items: employee.connects,
          class: "w-48"
        },
        {},
        {
          default: ({ item }) => {
            return `${escape(item.type)}`;
          }
        }
      )}` : ``}`;
    }
  })}</div> <div class="col-span-2">${validate_component(Skeleton, "Skeleton").$$render($$result, { size: "md", class: "my-8" }, {}, {})}</div> ${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Channel" }, {}, {
    default: () => {
      return `<div class="flex flex-col gap-3">${validate_component(Button, "Button").$$render($$result, {}, {}, {
        default: () => {
          return `Whatsapp`;
        }
      })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
        default: () => {
          return `SMS`;
        }
      })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
        default: () => {
          return `Email`;
        }
      })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
        default: () => {
          return `App`;
        }
      })}</div>`;
    }
  })}</div>`;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
